import React, { useEffect, useRef, useState } from "react";
import { Stepper, StepperRefAttributes } from "primereact/stepper";
import { Steps } from "primereact/steps";
import { Button } from "primereact/button";
import ClientPolicyStep from "./ClientPolicyStep";
import UploadDocumentStep from "./UploadDocumentStep";
import { Toast } from "primereact/toast";
import CommonValues from "../common/utils";
import { useNavigate } from "react-router-dom";
import TemplateStep from "./TemplateStep";
import AddVideoStep from "./AddVideoStep";
import PreviewStep from "./PreviewStep";
import axios, { AxiosProgressEvent } from "axios";
import ExistingPolicyListStep from "./ExistingPolicyListStep";

export default function QuoteStepper() {
  const navigate = useNavigate();
  const toast: any = useRef(null);

  const [transactionId, setTransactionId] = useState(null);
  const [nowCertPolicyData, setNowCertPolicyData] = useState<any>([]);
  const [nowCertQuoteData, setNowCertQuoteData] = useState<any>([]);
  const [nowcertsPolicyLoading, setNowcertsPolicyLoading] = useState(false);
  const [clientName, setClientName] = useState("");
  const [clientId, setClientId] = useState("");
  const [search, setSearch] = useState("");
  const [selectedPolicyId, setSelectedPolicyId] = useState("");
  const [selectedPolicy, setSelectedPolicy] = useState<any>(null);
  const [selectedQuoteId, setSelectedQuoteId] = useState("");
  const [selectedQuote, setSelectedQuote] = useState<any>([]);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [selectedTemplate, setSelectedTemplate] = useState("");
  const [videoUrl, setVideoUrl] = useState("");
  const [loading, setLoading] = useState(false);
  const [progress, setProgress] = useState<number>(0);
  const [processing, setProcessing] = useState(false);
  const [fileName, setFileName] = useState("");
  const [fileURL, setFileURL] = useState("");
  const [activeIndex, setActiveIndex] = useState(0);
  const [policyDetailsForDraft, setPolicyDetailsForDraft] = useState("");
  const [quoteDetailsForDraft, setQuoteDetailsForDraft] = useState("");
  const [documentType, setDocumentType] = useState("");
  const [viewDocumentLoading, setViewDocumentLoading] = useState(false);
  const [uploadedDocumentUrl, setUploadedDocumentUrl] = useState("");
  const [showDocument, setShowDocument] = useState(false);
  const [documentTypeError, setDocumentTypeError] = useState("");
  const [isQuoteSelected, setIsQuoteSelected] = useState(false);
  const [isDocumentSelected, setIsDocumentSelected] = useState(false);
  const [coverageDetails, setCoverageDetails] = useState<any>([]);
  const [driverList, setDriverList] = useState([]);
  const [vehicleList, setVehicleList] = useState([]);

  const options = [
    { label: "General Liability", value: "General Liability" },
    { label: "Auto", value: "Auto" },
    { label: "Workers Compensation", value: "Workers Compensation" },
  ];
  const getStepClass = (index: number) => {
    if (index < activeIndex) return "step-completed";
    if (index === activeIndex) return "step-active";
    return "step-upcoming";
  };

  const items = [
    { label: "Client & Quote", className: getStepClass(0) },
    { label: "Policy for a comparison(Optional)", className: getStepClass(1) },
    { label: "Select Template", className: getStepClass(2) },
    { label: "Add Video(Optional)", className: getStepClass(3) },
    { label: "Preview & Send", className: getStepClass(4) },
  ];

  useEffect(() => {
    getDraftDataById();
  }, [window.location.pathname.split("/")[2]]);

  const getDraftDataById = () => {
    setIsDocumentSelected(false);
    setIsQuoteSelected(false);
    setDocumentType("");
    setSelectedFile(null);
    setClientName("");
    setSelectedQuoteId("");
    const token = CommonValues.GetToken();
    // setSpinnerLoading(true);
    var config = {
      method: "get",
      url: `${process.env.REACT_APP_DataFabric_Url}/api/NCQuoteProposal/getdraftdata?transactionId=${window.location.pathname.split("/")[2]}`,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    axios(config)
      .then((response: any) => {
        if (response?.data) {
          const policyDetailsStr = response.data.policyDetails;
          const quoteDetailsStr = response.data.quoteDetails;

          let parsedQuoteDetails = typeof quoteDetailsStr === "string" ? JSON.parse(quoteDetailsStr) : quoteDetailsStr;
          let parsedPolicyDetails = typeof quoteDetailsStr === "string" ? JSON.parse(policyDetailsStr) : policyDetailsStr;

          if (parsedQuoteDetails && Object.keys(parsedQuoteDetails).length > 0) {
            setIsQuoteSelected(true);
            setQuoteDetailsForDraft(response.data.quoteDetails);
          }

          if (parsedPolicyDetails && Object.keys(parsedPolicyDetails).length > 0) {
            setPolicyDetailsForDraft(response.data.policyDetails);
          }
          if (response.data.clientId !== null) {
            setClientId(response.data.clientId);
            getNowCertsPoliciesList(response.data.clientId, policyDetailsStr, quoteDetailsStr);
          }

          if (response.data.clientName !== null) {
            setClientName(response.data.clientName);
          }

          if (response.data.templateId !== null) {
            setSelectedTemplate(response.data.templateId);
          }
          if (response.data.videoUrl !== null) {
            setVideoUrl(response.data.videoUrl);
          }
          if (response.data.fileName !== null) {
            setFileName(response.data.fileName);
            setFileURL(response.data.fileURL);
            setIsDocumentSelected(true);
          }
          if (response.data.documentType !== null) {
            setDocumentType(response.data.documentType);
          }
          setTimeout(() => {
            if (response.data.videoUrl != null) {
              getStepClass(3);
              setActiveIndex(3);
            } else if (response.data.templateId != 0 && response.data.templateId != null) {
              getStepClass(2);
              setActiveIndex(2);
            } else if (response.data.policyDetails !== null) {
              getStepClass(1);
              setActiveIndex(1);
            } else if (response.data.quoteDetails != null || response.data.fileName !== null) {
              getStepClass(0);
              setActiveIndex(0);
            } else {
              getStepClass(0);
              setActiveIndex(0);
            }
          }, 1000);
        }
      })
      .catch((error: any) => {
        // setSpinnerLoading(false);

        if (error.response != null) {
          if (error.response.status === 401) {
            CommonValues.Logout(navigate);
          } else {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: "Unknown error while loading the details",
              life: 3000,
            });
          }
        }
      });
  };
  const getNowCertsPoliciesList = (insuredId: string, policyDetailsStr: any, quoteDetailsStr: any) => {
    setNowcertsPolicyLoading(true);
    let nowCertsToken = localStorage.getItem("NCToken") || "";

    axios({
      method: "GET",
      url: `${process.env.REACT_APP_NOWCERTSAPI}/api/nowcert/insuredpolicies?insuredId=${insuredId}&nowCertsToken=${nowCertsToken}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("igtoken")}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        if (response.data.length > 0) {
          let filteredQuote;
          let filteredPolicies = response.data.filter((policy: any) => {
            const lob = policy.linesOfBusiness;
            if (!lob || lob.length === 0) {
              return false;
            }
            return lob.some(
              (line: any) =>
                line === "Worker's Compensation" ||
                line === "Workers Compensation" ||
                line === "General Liability" ||
                line.toLowerCase().includes("auto")
            );
          });
          const quoteData = filteredPolicies.filter((policy: any) => policy.isQuote === true);
          const policyData = filteredPolicies.filter((policy: any) => policy.isQuote === false);
          setNowCertQuoteData(quoteData);
          setNowCertPolicyData(policyData);

          if (policyDetailsStr) {
            const policyDetailsObj = JSON.parse(policyDetailsStr);
            const DatabaseId = policyDetailsObj["DatabaseId"];
            setSelectedPolicyId(DatabaseId);

            filteredPolicies.forEach((item: any) => {
              if (DatabaseId === item.databaseId) {
                setSelectedPolicy(item);
              }
            });
          }
          if (quoteDetailsStr) {
            const quoteDetailsObj = JSON.parse(quoteDetailsStr);
            const DatabaseId = quoteDetailsObj["DatabaseId"];
            setSelectedQuoteId(DatabaseId);

            filteredPolicies.forEach((item: any) => {
              if (DatabaseId === item.databaseId) {
                setSelectedQuote(item);
              }
            });
          }
        } else {
          setNowCertQuoteData([]);
          setNowCertPolicyData([]);
        }
        setNowcertsPolicyLoading(false);
      })
      .catch((error) => {
        setNowcertsPolicyLoading(false);
        if (error.response?.status === 401) {
          CommonValues.Logout(navigate);
        } else {
          toast.current?.show({
            severity: "error",
            summary: "Error",
            detail: "Unknown error while loading the client policy. Please try again later.",
            life: 3000,
          });
        }
      });
  };
  const getPolicyCoverageDetailList = (policyId: any) => {
    let nowCertsToken = localStorage.getItem("NCToken") ? localStorage.getItem("NCToken") : "";
    const config = {
      method: "GET",
      url: `${process.env.REACT_APP_NOWCERTSAPI}/api/nowcert/getpolicyCoverageslist?policyId=${policyId}&ncToken=${nowCertsToken}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("igtoken")}`,
        "Content-Type": "application/json",
      },
    };

    axios(config)
      .then((response) => {
        setCoverageDetails(response.data);
      })
      .catch((error) => {
        if (error.response != null) {
          if (error.response.status === 401) {
            CommonValues.Logout(navigate);
          } else {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: "Unknown error while getting policyendorsementdetaillist ",
              life: 3000,
            });
          }
        }
      });
  };
  const getDriverList = (insuredId: string) => {
    let nowCertsToken = localStorage.getItem("NCToken") ? localStorage.getItem("NCToken") : "";
    var config = {
      method: "GET",
      url: `${process.env.REACT_APP_NOWCERTSAPI}/api/nowcert/driverlist?insuredId=${insuredId}&ncToken=${nowCertsToken}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("igtoken")}`,
        "Content-Type": "application/json",
      },
    };

    axios(config)
      .then((response) => {
        setDriverList(response.data);
      })
      .catch((error) => {
        let errorMessage = "";
        if (error.response != null) {
          if (error.response.status === 401) {
            CommonValues.Logout(navigate);
          } else {
            if (toast.current) {
              toast.current.show({
                severity: "error",
                summary: "Error",
                detail: "Unknown error while get driver list.Please try again later",
                life: 3000,
              });
            }
          }
        }
      });
  };
  const getVehicleList = (insuredId: string) => {
    let nowCertsToken = localStorage.getItem("NCToken") ? localStorage.getItem("NCToken") : "";
    const config = {
      method: "GET",
      url: `${process.env.REACT_APP_NOWCERTSAPI}/api/nowcert/vehicles?&insuredDatabaseId=${insuredId}&ncToken=${nowCertsToken}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("igtoken")}`,
        "Content-Type": "application/json",
      },
    };

    axios(config)
      .then((response) => {
        if (response.data && Array.isArray(response.data.value) && response.data.value.length > 0) {
          setVehicleList(response.data.value);
        } else {
          setVehicleList([]);
        }
      })
      .catch((error) => {
        let errorMessage = "";
        if (error.response != null) {
          if (error.response.status === 401) {
            CommonValues.Logout(navigate);
          } else {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: "Unknown error while getting existing vehicle data.",
              life: 3000,
            });
          }
        }
      });
  };
  const onClientSelect = (client: any) => {
    setSearch("");
    setClientName(client.name);
    setClientId(client.databaseId);
    getNowCertsPoliciesList(client.databaseId, null, null);
  };

  const onPolicySelected = (policy: any) => {
    setPolicyDetailsForDraft("");
    setSelectedPolicyId(policy.databaseId);
    setSelectedPolicy(policy);
  };
  const onQuoteSelected = (quote: any) => {
    setQuoteDetailsForDraft("");
    setSelectedQuoteId(quote.databaseId);
    setSelectedQuote(quote);
    setSelectedFile(null);
    setFileName("");
    setFileURL("");
    setDocumentTypeError("");
    getDriverList(clientId);
    getVehicleList(clientId);
    getPolicyCoverageDetailList(quote.databaseId);

    if (quote?.linesOfBusiness?.length > 0) {
      setDocumentType(quote.linesOfBusiness[0].toLowerCase().includes("auto") ? "Auto" : quote.linesOfBusiness[0]);
    }
  };
  const onDocumentTypeChage = (e: any) => {
    setDocumentType(e.target.value);
    setDocumentTypeError("");
  };
  const CreateDraft = () => {
    setLoading(true);
    setProgress(0);
    setProcessing(false);

    // let documentTypes = "";
    // if (selectedQuote?.linesOfBusiness?.length > 0) {
    //   documentTypes = selectedQuote.linesOfBusiness[0].toLowerCase().includes("auto") ? "Auto" : selectedQuote.linesOfBusiness[0];
    // } else {
    //   documentTypes = documentType;
    // }
    let data = new FormData();
    if (selectedFile) {
      data.append("file", selectedFile);
    }

    let quote: any = {
      "Total Premium": selectedQuote.totalPremium,
      "Policy Number": selectedQuote.policyNumber,
      DatabaseId: selectedQuote.databaseId,
      "Carrier Name": selectedQuote.carrierName,
      Term: selectedQuote.policyTermInMonths,
      "Effective Date": selectedQuote.effectiveDate,
      "Expiration Date": selectedQuote.expirationDate,
      // "Coverage Details": coverageDetails,
      // "Driver List": driverList,
      // "Vehicle List": vehicleList,
    };
    if (Array.isArray(coverageDetails) && coverageDetails.length > 0) {
      quote["Coverage Details"] = coverageDetails;
    }
    if (Array.isArray(driverList) && driverList.length > 0) {
      quote["Driver List"] = driverList;
    }
    if (Array.isArray(vehicleList) && vehicleList.length > 0) {
      quote["Vehicle List"] = vehicleList;
    }
    let quoteDetails = "";

    if (quoteDetailsForDraft && quoteDetailsForDraft !== "") {
      quoteDetails = quoteDetailsForDraft;
    } else if (quote) {
      quoteDetails = JSON.stringify(quote);
    }
    let policy;
    if (selectedPolicy) {
      policy = {
        "Total Premium": selectedPolicy.totalPremium,
        "Policy Number": selectedPolicy.policyNumber,
        DatabaseId: selectedPolicy.databaseId,
        "Carrier Name": selectedPolicy.carrierName,
        Term: selectedPolicy.policyTermInMonths,
        "Effective Date": selectedPolicy.effectiveDate,
        "Expiration Date": selectedPolicy.expirationDate,
      };
    }
    let policyDetails = "";

    if (policyDetailsForDraft && policyDetailsForDraft !== "") {
      policyDetails = policyDetailsForDraft;
    } else if (policy) {
      policyDetails = JSON.stringify(policy);
    }
    data.append("policyDetails", policyDetails);
    data.append("quoteDetails", quoteDetails);
    data.append("documentType", documentType);
    data.append("templateId", selectedTemplate);
    data.append("videoUrl", videoUrl ?? "");
    data.append("transactionId", window.location.pathname.split("/")[2]);
    data.append("clientId", clientId);
    data.append("clientName", clientName);
    data.append("fileURL", fileURL);
    data.append("fileName", fileName);
    axios
      .post(`${process.env.REACT_APP_DataFabric_Url}/api/NCQuoteProposal/draft`, data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("igtoken")}`,
        },
        onUploadProgress: (progressEvent: AxiosProgressEvent) => {
          if (progressEvent.total) {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            setProgress(percentCompleted);

            if (percentCompleted >= 100) {
              setProcessing(true);
            }
          }
        },
      })
      .then((response: any) => {
        setTransactionId(response.data.transactionId);
        setLoading(false);
      })
      .catch((error: any) => {
        setLoading(false);
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
        setProcessing(false);
      });
  };

  const onFileSelected = (e: any) => {
    if (e.files?.length > 0) {
      setSelectedFile(e.files[0]);
      setFileName(e.files[0].name);
      setSelectedQuoteId("");
      setSelectedQuote([]);
    } else {
      setSelectedFile(null);
    }
  };

  const onTemplateSelect = (templateId: any) => {
    setSelectedTemplate(templateId);
  };
  const onVideoUrlChange = (url: any) => {
    setVideoUrl(url);
  };

  const onQuoteChange = (e: any) => {
    const selected = e.value;
    setIsQuoteSelected(selected);
    if (selected) setIsDocumentSelected(false);
  };

  const onDocumentChange = (e: any) => {
    const selected = e.value;
    setIsDocumentSelected(selected);
    if (selected) setIsQuoteSelected(false);
  };
  const onViewDocumentClicked = () => {
    setViewDocumentLoading(true);

    axios({
      method: "POST",
      url: `${process.env.REACT_APP_DataFabric_Url}/api/NCQuoteProposal/viewdocument?transactionId=${
        window.location.pathname.split("/")[2]
      }&fileName=${fileName}`,
      headers: {
        Authorization: `Bearer ${localStorage.getItem("igtoken")}`,
        "Content-Type": "application/json",
      },
    })
      .then((response) => {
        setViewDocumentLoading(false);
        setUploadedDocumentUrl(response.data.fileURL);
        setShowDocument(true);
      })
      .catch((error) => {
        setViewDocumentLoading(false);
        setShowDocument(false);
        if (error.response?.status === 401) {
          CommonValues.Logout(navigate);
        } else {
          toast.current?.show({
            severity: "error",
            summary: "Error",
            detail: "Unknown error while getting the uploaded file",
            life: 3000,
          });
        }
      });
  };
  const renderStepContent = () => {
    let index = activeIndex == 5 ? 4 : activeIndex;

    switch (index) {
      case 0:
        return (
          <>
            <ClientPolicyStep
              nowCertQuoteData={nowCertQuoteData}
              getNowCertsPoliciesList={getNowCertsPoliciesList}
              onClientSelect={onClientSelect}
              clientName={clientName}
              search={search}
              setSearch={setSearch}
              nowcertsPolicyLoading={nowcertsPolicyLoading}
              onQuoteSelected={onQuoteSelected}
              selectedQuoteId={selectedQuoteId}
              isQuoteSelected={isQuoteSelected}
              isDocumentSelected={isDocumentSelected}
              onDocumentChange={onDocumentChange}
              onQuoteChange={onQuoteChange}
            />
            {isDocumentSelected ? (
              <UploadDocumentStep
                onFileSelected={onFileSelected}
                selectedFile={selectedFile}
                fileName={fileName}
                fileURL={fileURL}
                onViewDocumentClicked={onViewDocumentClicked}
                uploadedDocumentUrl={uploadedDocumentUrl}
                viewDocumentLoading={viewDocumentLoading}
                showDocument={showDocument}
                onCloseDocumentDialogClick={onCloseDocumentDialogClick}
                allDocumentType={options}
                onDocumentTypeChage={onDocumentTypeChage}
                documentType={documentType}
                documentTypeError={documentTypeError}
              />
            ) : null}
            <div className=" border-top pt-3 px-4 d-flex justify-content-end mb-2">
              <Button label="Next" icon="fa fa-arrow-right" iconPos="right" onClick={handleNext} className="company-save-btn" />
            </div>
          </>
        );
      case 1:
        return (
          <>
            <ExistingPolicyListStep
              clientName={clientName}
              nowCertPolicyData={nowCertPolicyData}
              onPolicySelected={onPolicySelected}
              selectedPolicyId={selectedPolicyId}
            />

            <div className="border-top pt-3 px-4 d-flex justify-content-between mb-2">
              <Button label="Back" severity="secondary" icon="fa fa-arrow-left" onClick={handleBack} style={{ borderRadius: "6px" }} />
              {selectedPolicyId != null && selectedPolicyId != undefined && selectedPolicyId != "" ? (
                <Button label="Next" icon="fa fa-arrow-right" iconPos="right" onClick={handleNext} className="company-save-btn" />
              ) : (
                <Button label="Skip" icon="fa fa-arrow-right" iconPos="right" onClick={handleNext} className="company-save-btn" />
              )}
            </div>
          </>
        );
      case 2:
        return (
          <>
            <TemplateStep selectedTemplate={selectedTemplate} onTemplateSelect={onTemplateSelect} />
            <div className="border-top pt-3 px-4 d-flex justify-content-between mb-2">
              <Button label="Back" severity="secondary" icon="fa fa-arrow-left" onClick={handleBack} style={{ borderRadius: "6px" }} />
              <Button label="Next" icon="fa fa-arrow-right" iconPos="right" onClick={handleNext} className="company-save-btn" />
            </div>
          </>
        );
      case 3:
        return (
          <>
            <AddVideoStep videoUrl={videoUrl} onVideoUrlChange={onVideoUrlChange} />
            <div className="border-top pt-3 px-4 d-flex justify-content-between mb-2">
              <Button label="Back" severity="secondary" icon="fa fa-arrow-left" onClick={handleBack} style={{ borderRadius: "6px" }} />
              {videoUrl != null && videoUrl != "" ? (
                <Button label="Next" icon="fa fa-arrow-right" iconPos="right" onClick={handleNext} className="company-save-btn" />
              ) : (
                <Button label="Skip" icon="fa fa-arrow-right" iconPos="right" onClick={handleNext} className="company-save-btn" />
              )}{" "}
            </div>
          </>
        );
      case 4:
        return (
          <>
            <PreviewStep
              selectedFile={selectedFile}
              selectedPolicy={selectedPolicy}
              selectedQuote={selectedQuote}
              selectedTemplate={selectedTemplate}
              videoUrl={videoUrl}
              setTransactionId={setTransactionId}
              fileName={fileName}
              fileURL={fileURL}
              documentType={documentType}
              clientName={clientName}
              coverageDetails={coverageDetails}
              driverList={driverList}
              vehicleList={vehicleList}
            />
          </>
        );
    }
  };
  const handleBack = () => {
    if (activeIndex == 5) {
      setActiveIndex((prev) => prev - 2);
    } else {
      setActiveIndex((prev) => prev - 1);
    }
  };
  const onCloseDocumentDialogClick = () => {
    setShowDocument(false);
  };
  const handleNext = () => {
    switch (activeIndex) {
      case 0:
        if (!clientName) {
          toast.current.show({
            severity: "warn",
            summary: "Warning",
            detail: "Please select the client ",
            life: 3000,
          });
          return;
        } else if (!isQuoteSelected && !isDocumentSelected) {
          toast.current.show({
            severity: "warn",
            summary: "Warning",
            detail: "Please  Select a Quote from AMS or Upload a Quote Letter.",
            life: 3000,
          });
          return;
        } else if (isQuoteSelected && !selectedQuoteId) {
          toast.current.show({
            severity: "warn",
            summary: "Warning",
            detail: "Please select an existing quote.",
            life: 3000,
          });
          return;
        } else if (isDocumentSelected && !selectedFile && (!fileURL || fileURL === "")) {
          toast.current.show({
            severity: "warn",
            summary: "Warning",
            detail: "Please select file.",
            life: 3000,
          });
          return;
        }

        // if (!clientName || (!selectedQuoteId && !selectedFile && (!fileURL || fileURL === ""))) {
        //   toast.current.show({
        //     severity: "warn",
        //     summary: "Warning",
        //     detail: "Please select the client and either upload a file or select an existing quote.",
        //     life: 3000,
        //   });
        //   return;
        // }
        else if ((selectedFile || (fileURL && fileURL !== "")) && (documentType === null || documentType === "")) {
          setDocumentTypeError("Please select line of business");
          return;
        } else {
          CreateDraft();
        }
        break;
      case 1:
        // if (!selectedFile && (fileURL == "" || fileURL == null)) {
        //   toast.current.show({ severity: "warn", summary: "Warning", detail: "Please upload file", life: 3000 });
        //   return;
        // } else {
        CreateDraft();
        // }
        break;
      case 2:
        if (!selectedTemplate) {
          toast.current.show({ severity: "warn", summary: "Warning", detail: "Please select template", life: 3000 });
          return;
        } else {
          CreateDraft();
        }
        break;
      case 3:
        CreateDraft();
        break;
    }
    setActiveIndex((prev) => prev + 1);
  };

  return (
    <div className="quote-proposal-stepper w-100">
      <Toast ref={toast} />
      <Steps model={items} activeIndex={activeIndex} onSelect={(e) => setActiveIndex(e.index)} readOnly={false} className="mb-4" />
      <div className="d-flex flex-column h-12rem border border-secondary-subtle rounded">{renderStepContent()}</div>
    </div>
  );
}
